import { render, staticRenderFns } from "./ModalImportLeads.vue?vue&type=template&id=20e61f3e"
import script from "./ModalImportLeads.vue?vue&type=script&lang=js"
export * from "./ModalImportLeads.vue?vue&type=script&lang=js"
import style0 from "./ModalImportLeads.vue?vue&type=style&index=0&id=20e61f3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports